import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-delete-icon',
  template: `
    <svg class="svg-icon icon-icon">
      <use xlink:href="./assets/svg/app-sections.svg#icon-delete"></use>
    </svg>
  `,
  styles: [
    `
      :host {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteIconComponent {
  @Input() fillColor: string;
}
